import { useKeycloak } from "@react-keycloak/web";
import Content from "../../components/main/Content";
import Searchbar from "../../components/main/Searchbar";


export default function Main() {
    const { initialized } = useKeycloak();

    return (
        <>
            {!initialized ?
                <div className="flex-col align-center">
                    <div className="title">
                        Featurely
                    </div>
                    <div className="secondary-title">
                        by New Labs
                    </div>
                </div>
            :
                <div id="main-layout" className="flex-col">
                    <Searchbar />
                    <Content />
                </div>
            }
        </>
    )
}